import { useState } from 'react'
import type { FormEvent } from 'react'
import { useLoginMutation } from '~/api/endpoints/auth'
import { errorMessage } from '~/api/baseQuery'
import { loggedIn } from '~/app/authSlice'
import { useAppDispatch } from '~/app/hooks'
import { Button } from '~/components/primitives/Button'
import { Field, Input } from '~/components/primitives/Field'
import { InlineError } from '~/components/primitives/Feedback'

export function LoginPage() {
  const dispatch = useAppDispatch()
  const [login, { isLoading }] = useLoginMutation()
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)

  async function onSubmit(event: FormEvent) {
    event.preventDefault()
    setError(null)
    try {
      // Checked before it is kept, so a typo is answered here rather than by whatever
      // screen the operator opened next.
      await login(password).unwrap()
      dispatch(loggedIn(password))
    } catch (cause) {
      setError(errorMessage(cause, 'That password was not accepted'))
    }
  }

  return (
    <div className="flex h-dvh items-center justify-center bg-ground p-4">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-xs rounded-md border border-line bg-surface p-5"
        style={{ boxShadow: 'var(--shadow)' }}
      >
        <div className="mb-5 flex items-center gap-2">
          <span className="h-2 w-2 rounded-full bg-signal" aria-hidden />
          <span className="label text-text">Outreach engine</span>
        </div>

        <Field label="Password" hint="One password, held by the engine.">
          {(id) => (
            <Input
              id={id}
              type="password"
              autoFocus
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          )}
        </Field>

        {error ? (
          <div className="mt-3">
            <InlineError message={error} />
          </div>
        ) : null}

        <Button
          type="submit"
          variant="primary"
          busy={isLoading}
          disabled={password.length === 0}
          className="mt-4 w-full"
        >
          Sign in
        </Button>
      </form>
    </div>
  )
}
